export interface News {
  title: string
  content: string
  link: string
  date: Date
}

export const newsList: News[] = [
  {
    title: "Tir du Roy de Région",
    content: 'Nouvelle épreuve "Traditions"',
    link: "/vie-sportive/championnats-regionaux/",
    date: new Date(2026, 3, 2),
  },
  {
    title: "Division Régionale Excellence 2026",
    content: "Les inscriptions sont ouvertes !",
    link: "/vie-sportive/dre/",
    date: new Date(2026, 1, 15),
  },
  {
    title: "Championnat Régional salle 2026",
    content: "La période sélective est terminée. Confirmez votre inscription avant le 5 février.",
    link: "/vie-sportive/championnats-regionaux/",
    date: new Date(2026, 1, 2),
  },
  {
    title: "Championnat Régional salle 2026",
    content: "Les pré-inscriptions pour les championnats régionaux en salle (à Mulhouse les 7 et 8 février) sont ouvertes.",
    link: "/vie-sportive/championnats-regionaux/",
    date: new Date(2025, 11, 22),
  },
  {
    title: "Championnat Régional Beursault 2025",
    content: "Le classement du Championnat Régional Beursault 2025 est en ligne.",
    link: "/vie-sportive/championnats-regionaux/",
    date: new Date(2025, 8, 16),
  },
  {
    title: "Division Régionale Excellence 2025",
    content: "Les équipes de Troyes (FCL), Épernay (FCO), Hayange (HCL) et Vendeuvre-sur-Barse (HCO) sont nos Championnes Régionales 2025 !",
    link: "/vie-sportive/dre/",
    date: new Date(2025, 5, 23),
  },
  {
    title: "Formations 2026",
    content: "Les nouvelles sessions de formations 2026 sont ouvertes aux inscriptions",
    link: "/formations/",
    date: new Date(2025, 4, 20),
  },
  {
    title: "Candidature Championnats Régionaux 2027",
    content: "Responsables de clubs, vous avez la possibilité de proposer votre candidature à l'organisation d'un championnat régional pour la saison prochaine.",
    link: "/vie-sportive/championnats-regionaux/",
    date: new Date(2025, 11, 2),
  },
  // {
  //   title: "Assemblée Générale Élective 2024",
  //   content: "L'AG élective pour renouveler le Comité du CRTA Grand Est aura lieu en distanciel le 30 novembre 2024. Vous trouverez la convocation (pour les présidents de clubs) et la composition de la liste candidate en suivant ce lien",
  //   link: "/comite-regional/pv-ag/",
  //   date: new Date(2024, 10, 8),
  // },
]
